import { Box, Paper, Stack, Typography } from "@mui/material";
import { metricGradients } from "../constants/designTokens";

export default function KpiCard({ label, value, variant = "blue", icon: Icon }) {
  return (
    <Paper
      elevation={0}
      sx={{
        minHeight: 104,
        borderRadius: 3,
        p: 2.1,
        overflow: "hidden",
        position: "relative",
        color: "#fff",
        background: metricGradients[variant],
        boxShadow: "0 14px 24px rgba(18, 35, 64, 0.16)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: 92,
          height: 92,
          borderRadius: "50%",
          top: -26,
          right: -22,
          bgcolor: "rgba(255,255,255,0.09)",
        }}
      />
      <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0, position: "relative" }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "rgba(255,255,255,0.13)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon sx={{ fontSize: 18 }} />
        </Box>
        <Typography
          sx={{
            fontSize: 11,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            opacity: 0.72,
            fontWeight: 900,
            lineHeight: 1.25,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {label}
        </Typography>
      </Stack>
      <Typography
        sx={{
          mt: 1.25,
          fontSize: 21,
          fontWeight: 900,
          letterSpacing: "-0.02em",
          position: "relative",
          textAlign: "right",
        }}
      >
        {value}
      </Typography>
    </Paper>
  );
}
